<template>
    <Navbar/>
    <Blog7Body/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import Blog7Body from "@/components/blog/Blog7Body.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "Blog7View",
    components: {
      Navbar,
      Blog7Body,
      Footer
    },
  });
  </script>
  